import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UploadDocumentRequest {
    fileName: string;
    contentType: string;
}